module.exports = __webpack_public_path__ + "static/john-schnobrich-2FPjlAyMQTA-unsplash-fit-db2a4eebbe47e473e8298525c9785044.jpg";